<template>
  <!-- 个人中心 -->
  <div class="index-container">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="week-box">
          <div
            class="week"
            v-for="(item, index) in weekList"
            :key="'week' + index"
            :class="weekActive === index ? 'week-active' : ''"
            @click="weekSelect(index)"
          >{{ item }}</div>
        </div>
        <template v-if="weekActive === 0">
          <div class="date-text">
            <i class="iconfont el-icon-arrow-left" @click="monthReduce"></i>
            <span>{{nowYear}}年{{ weekDetail.month }}月</span>
            <i class="iconfont el-icon-arrow-right" @click="monthAdd"></i>
          </div>
          <div class="class-schedule">
            <div class="table-title">
              <div class="month">{{ weekDetail.month }}月</div>
              <div class="month">时间</div>
              <div class="week-text" v-for="(item, index) in weekDetail.date" :key="index">
                <span>{{ item.week }}</span>
                <div>{{ item.date }}</div>
              </div>
              <!-- <div class="week-text">
                <span>二</span>
                <div>04/16</div>
              </div>
              <div class="week-text">
                <span>三</span>
                <div>04/16</div>
              </div>
              <div class="week-text">
                <span>四</span>
                <div>04/16</div>
              </div>
              <div class="week-text">
                <span>五</span>
                <div>04/16</div>
              </div>
              <div class="week-text">
                <span>六</span>
                <div>04/16</div>
              </div>
              <div class="week-text">
                <span>日</span>
                <div>04/16</div>
              </div>-->
            </div>
            <div class="table-box">
              <div class="t-text f-text">上</div>
              <div class="t-text">08:00 - 09:00</div>
              <div
                class="t-words"
                v-for="(item, index) in weekDetail.time_list1"
                :key="'t1' + index"
              >
                {{ item["section"].section_title
                }}
                <span
                  v-if="item['section'].address"
                >({{ item["section"].address }})</span>
              </div>
            </div>
            <div class="table-box super-box">
              <div class="t-text f-text">午</div>
              <div class="t-text">10:00 - 11:00</div>
              <div
                class="t-words"
                v-for="(item, index) in weekDetail.time_list2"
                :key="'t2' + index"
              >
                {{ item["section"].section_title }}
                <span
                  v-if="item['section'].address"
                >({{ item["section"].address }})</span>
              </div>
            </div>
            <div class="table-box">
              <div class="t-text f-text">下</div>
              <div class="t-text">13:00 - 14:00</div>
              <div
                class="t-words"
                v-for="(item, index) in weekDetail.time_list3"
                :key="'t3' + index"
              >
                {{ item["section"].section_title }}
                <span
                  v-if="item['section'].address"
                >({{ item["section"].address }})</span>
              </div>
            </div>
            <div class="table-box">
              <div class="t-text f-text">午</div>
              <div class="t-text">15:00 - 16:00</div>
              <div
                class="t-words"
                v-for="(item, index) in weekDetail.time_list4"
                :key="'t4' + index"
              >
                {{ item["section"].section_title }}
                <span
                  v-if="item['section'].address"
                >({{ item["section"].address }})</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <vue-event-calendar
            :events="demoEvents"
            @day-changed="dayChange"
            @month-changed="handleMonthChanged"
          >
            <!-- <template scope="props">
              <div
                v-for="(event, index) in props.showEvents"
                :key="index"
                class="event-item"
              >
                {{ event }}
              </div>
            </template>-->
          </vue-event-calendar>
          <!-- <el-calendar v-model="dateStr"></el-calendar> -->
          <div class="thing-box">
            <div
              class="thing-list"
              v-for="(item, index) in thingList"
              :key="'thing' + index"
              @click="goMyCourse(item)"
            >
              <div class="time-box">{{ item.start_time }}——{{ item.end_time }}</div>
              <div class="t-box">
                <div
                  class="t-img"
                  :style="{
                    backgroundImage: 'url( ' + imgUrl + item.cover + ')'
                  }"
                ></div>
                <div class="r-box">
                  <div class="t-title">{{ item.section_title }}</div>
                  <div class="t-teacher">讲师：{{ item.teacher }}</div>
                  <div class="t-address">
                    <span>{{ item.class_model }}</span>
                    {{ item.address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </personalSidebar>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import { imgUrl } from '../api/index';
import api from '../api/api';
export default {
  name: 'personalCenter',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      bannerText: '个人中心',
      weekActive: 0,
      weekList: ['周', '日历'],
      thingList: [],
      weekDetail: {},
      date: '',
      demoEvents: [],
      imgUrl: imgUrl,
      nowYear: '',
      Week: ''
    };
  },
  created() {
    this.getCourseWeek();
    this.getCourseMonth();
  },
  mounted() {
    scrollTo(0, 0);
    const dateValue = new Date();
    this.nowYear = dateValue.getFullYear();
  },
  methods: {
    //   月份减少
    monthReduce() {
      if (this.Week <= 1) {
        this.$message.warning('已是第一周！');
        return;
      }
      this.Week--;
      this.getCourseWeek();
    },
    //   月份增加
    monthAdd() {
      if (this.Week >= 4) {
        this.$message.warning('已是最后一周！');
        return;
      }
      this.Week++;
      this.getCourseWeek();
    },
    getCourseWeek() {
      const params = {
        Week: this.Week
      };
      api.getCourseWeek(params).then(res => {
        if (res.result) {
          this.weekDetail = res.result;
          this.weekDetail.month = this.weekDetail.month.replace(/^0+/, '');
        }
      });
    },
    getCourseMonth() {
      const params = {
        month_type: 1,
        date: this.date
      };
      api.getCourseMonth(params).then(res => {
        console.log(res);
        if (res.result) {
          this.thingList = res.result.sec_info;
          let dateList = res.result.date;
          let is_hadList = [];
          dateList.map(ele => {
            if (ele.is_had == 1) {
              is_hadList.push({ date: ele.date.replace(/-/g, '/'), title: '' });
            }
          });
          console.log(is_hadList);
          this.demoEvents = is_hadList;
        }
      });
    },
    dayChange(day) {
      console.log(day);
      this.date = day.date;
      this.getCourseMonth();
    },
    handleMonthChanged(value) {
      const year = value.substring(0, 4);
      const month = value.substring(5, 7);
      this.date = year + '-' + month + '-' + '01';
      this.getCourseMonth();
    },
    weekSelect(index) {
      this.weekActive = index;
    },
    goMyCourse(item) {
      this.$router.push({
        path: '/myCourseDetail',
        query: { id: item.order_id, uuid: item.course_uuid }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 40PX 46PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  border-radius: 10PX;
}
.week-box {
  display: flex;
  width: 220PX;
  margin-bottom: 36PX;
  border-radius: 22PX;
  .week {
    width: 50%;
    color: #666666;
    line-height: 36PX;
    text-align: center;
    border-radius: 22PX 0 0 22PX;
    border: 1PX solid #d6d6d6;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background-color: #f6ab2b;
      border-color: #f6ab2b;
    }
    &:first-child {
      border-right: none;
    }
    &:last-child {
      border-left: none;
      border-radius: 0 22PX 22PX 0;
    }
  }
  .week-active {
    color: #ffffff;
    background-color: #f6ab2b;
    border-color: #f6ab2b;
  }
}
.date-text {
  padding-bottom: 34PX;
  font-size: 20PX;
  text-align: center;
  font-weight: 500;
  span {
    padding: 0 30PX;
  }
  .iconfont {
    font-size: 22PX;
    color: #666666;
    cursor: pointer;
  }
}
.class-schedule {
  width: 90%;
  margin: 0 auto;
  border: 1PX solid #dedede;
  border-radius: 10PX;
}
.table-title {
  display: flex;
  color: #ffffff;
  background-color: #f6ab2b;
  border-radius: 10PX 10PX 0PX 0PX;
  .month {
    width: 52PX;
    padding: 24PX 16PX;
    text-align: center;
  }
}
.table-title > div {
  border-right: 1PX solid #ffffff;
}
.week-text {
  width: 102PX;
  padding: 24PX 0;
  text-align: center;
  line-height: 20PX;
  &:last-child {
    border-right: none;
  }
  span {
    padding-bottom: 4PX;
  }
}

.table-box > div {
  border-right: 1PX solid #dedede;
}
.table-box {
  display: flex;
  .t-text {
    width: 52PX;
    padding: 32PX 5PX;
    color: #666666;
    text-align: center;
  }
  .f-text {
    padding: 60PX 16PX;
  }
  .t-words {
    width: 102PX;
    padding: 32PX 12PX;
    span {
      display: block;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.super-box {
  border-bottom: 1PX solid #dedede;
}
.thing-box {
  display: flex;
  //   justify-content: space-between;
  flex-wrap: wrap;
  padding: 30PX 10PX;
  .thing-list {
    width: 400PX;
    padding: 14PX 26PX;
    margin-bottom: 26PX;
    background-color: #f5f5f5;
    border: 1PX solid #f0f0f0;
    border-radius: 15PX;
    cursor: pointer;
    &:nth-child(2n + 1) {
      margin-right: 46PX;
    }
    &:hover {
      .t-title {
        color: #f6ab2b;
      }
    }
  }
  .time-box {
    padding-bottom: 14PX;
    font-size: 16PX;
    font-weight: 500;
    border-bottom: 1PX solid #e9e9e9;
  }
  .t-box {
    display: flex;
    padding: 16PX 4PX 2PX;
  }
  .t-img {
    flex-shrink: 0;
    width: 98PX;
    height: 94PX;
    margin-right: 20PX;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #e9e9e9;
  }
  .t-title {
    padding: 2PX 0 6PX;
    font-size: 18PX;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-teacher {
    padding-bottom: 12PX;
    font-weight: 500;
  }
  .r-box {
    width: calc(100% - 100PX);
  }
  .t-address {
    font-size: 12PX;
    color: #666666;
    span {
      padding: 2PX 6PX;
      margin-right: 10PX;
      font-size: 12PX;
      color: #ffffff;
      background-color: #ff7b1f;
      border-radius: 5PX;
    }
  }
}
@media screen and (max-width: 1700PX) {
  .thing-box {
    .thing-list {
      width: 360PX;
    }
  }
}
@media screen and (max-width: 1500PX) {
  .thing-box {
    // display: block;
    .thing-list {
      width: 400PX;
      // margin: 0 auto 26PX !important;
    }
  }
}
/deep/ {
  .__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .is-event {
    width: 10PX;
    height: 10PX;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 24PX;
    margin-left: 0;
    background-color: #e82929 !important;
    border-radius: 50%;
    border-color: transparent !important;
  }
  .event {
    .date-num {
      color: #666666 !important;
    }
  }
  .cal-body .dates .today .date-num {
    color: #ffffff !important;
  }
  .__vev_calendar-wrapper {
    .cal-wrapper {
      width: 100% !important;
      padding: 20PX 0 50PX;
    }
    .events-wrapper {
      display: none;
    }
    .cal-wrapper .cal-body .weeks,
    .cal-wrapper .cal-body .dates,
    .cal-body .dates .item .date-num {
      font-size: 18PX !important;
      color: #999999;
      cursor: pointer;
    }
    .cal-wrapper .cal-header .title {
      font-size: 20PX !important;
      font-weight: 500;
    }
    .cal-wrapper .cal-body .dates .item {
      margin-bottom: 20PX;
    }
    .cal-wrapper .cal-body .dates .item .is-today {
      width: 45PX;
      height: 45PX;
      margin: 0;
      top: 24%;
      left: 50%;
      transform: translateX(-50%);
      background: #ff7b1f;
      border-radius: 50%;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personalCenter.vue